import { type AllegatoRichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/allegatoRichiestaDTO.ts';
import { keyBy } from 'lodash';

const isOmissisRecord = (a: AllegatoRichiestaDTO) =>
  a.idFile == null && a.idFileOmissis != null;

/**
 * Chiave logica di un allegato: `codice + idSezioneDati`. Un allegato e la sua
 * versione omissis (record separati lato API) condividono la stessa chiave.
 */
export const getAttachmentKey = (a: AllegatoRichiestaDTO) =>
  `${a.codice ?? ''}-${a.idSezioneDati ?? ''}`;

/**
 * L'API ritorna gli allegati come record separati: ogni allegato con
 * versione omissis produce due record distinti (uno con idFile, uno
 * con idFileOmissis). Raggruppiamo per codice+sezione e inseriamo
 * la riga omissis subito dopo il suo parent, coerentemente con il
 * pattern usato in ExtendedModulesTable.
 */
export function sortAttachmentsWithOmissis(
  attachments: AllegatoRichiestaDTO[],
) {
  const records = attachments.filter(a => !isOmissisRecord(a));
  const omissisByKey = keyBy(
    attachments.filter(isOmissisRecord),
    getAttachmentKey,
  );

  return records.flatMap(attachment => {
    const omissis = omissisByKey[getAttachmentKey(attachment)];
    return omissis ? [attachment, omissis] : [attachment];
  });
}

/** Determina se un record allegato è la versione omissis. */
export function isOmissisAttachment(a: AllegatoRichiestaDTO) {
  return a.idFile == null && a.idFileOmissis != null;
}
